import { render } from "./Index.vue?vue&type=template&id=4c85f1d8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4c85f1d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c85f1d8"],['__file',"Views/Blog/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c85f1d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c85f1d8', __exports__)) {
    api.reload('4c85f1d8', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4c85f1d8&scoped=true", () => {
    api.rerender('4c85f1d8', render)
  })

}


export default __exports__